document.addEventListener("DOMContentLoaded", () => {
    const toggle = document.getElementById("hamburger-toggle");
    const menu = document.getElementById("mobile-menu");
    const iconOpen = document.getElementById("hamburger-icon");
    const iconClose = document.getElementById("close-icon");

    if (!toggle || !menu) return;

    const openMenu = () => {
        menu.classList.remove("hidden");
        toggle.setAttribute("aria-expanded", "true");
        if (iconOpen && iconClose) {
            iconOpen.classList.add("hidden");
            iconClose.classList.remove("hidden");
        }
    };

    const closeMenu = () => {
        menu.classList.add("hidden");
        toggle.setAttribute("aria-expanded", "false");
        if (iconOpen && iconClose) {
            iconOpen.classList.remove("hidden");
            iconClose.classList.add("hidden");
        }
    };

    const isOpen = () => !menu.classList.contains("hidden");

    toggle.addEventListener("click", () => {
        isOpen() ? closeMenu() : openMenu();
    });

    // Close when a menu link is clicked (nice on mobile)
    menu.addEventListener("click", (e) => {
        const target = e.target;
        if (target && target.closest("a")) closeMenu();
    });

    // Escape key closes
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && isOpen()) closeMenu();
    });

    // Scroll closes
    window.addEventListener("scroll", () => {
        if (isOpen()) closeMenu();
    });

    // If resizing to desktop, ensure the mobile menu is closed
    window.addEventListener("resize", () => {
        if (window.matchMedia("(min-width: 768px)").matches) {
            closeMenu();
        }
    });
});